import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
});

// Attach token from localStorage
api.interceptors.request.use((config) => {
    const token = localStorage.getItem("ep_token");
    if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

api.interceptors.response.use(
    (r) => {
        // Signal other tabs (e.g. public landing page) whenever admin writes content
        try {
            const method = (r.config?.method || "").toLowerCase();
            const url = r.config?.url || "";
            if (["put", "post", "delete"].includes(method) && url.includes("/content")) {
                localStorage.setItem("cms_updated", String(Date.now()));
            }
        } catch {}
        return r;
    },
    (err) => {
        if (err?.response?.status === 401) {
            // No login page anymore — just clear stale token so ensureToken() can refresh
            try {
                localStorage.removeItem("ep_token");
                localStorage.removeItem("ep_user");
            } catch {}
        }
        return Promise.reject(err);
    }
);

export function formatApiError(err) {
    const d = err?.response?.data?.detail;
    if (!d) return err?.message || "Something went wrong";
    if (typeof d === "string") return d;
    if (Array.isArray(d))
        return d
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .join(" ");
    return String(d);
}

// Content — cache-busting query prevents CDN/browser stale reads
const bust = () => ({ params: { _t: Date.now() } });
export const getSeminar = () => api.get("/content/seminar", bust()).then((r) => r.data);
export const putSeminar = (data) => api.put("/content/seminar", data).then((r) => r.data);
export const getVideos = () => api.get("/content/videos", bust()).then((r) => r.data);
export const putVideos = (data) => api.put("/content/videos", data).then((r) => r.data);
export const getMentor = () => api.get("/content/mentor", bust()).then((r) => r.data);
export const putMentor = (data) => api.put("/content/mentor", data).then((r) => r.data);

// Stories
export const listStories = () => api.get("/content/stories", bust()).then((r) => r.data);
export const createStory = (data) => api.post("/content/stories", data).then((r) => r.data);
export const updateStory = (id, data) => api.put(`/content/stories/${id}`, data).then((r) => r.data);
export const deleteStory = (id) => api.delete(`/content/stories/${id}`).then((r) => r.data);

// Reviews
export const listReviews = () => api.get("/content/reviews", bust()).then((r) => r.data);
export const createReview = (data) => api.post("/content/reviews", data).then((r) => r.data);
export const updateReview = (id, data) => api.put(`/content/reviews/${id}`, data).then((r) => r.data);
export const deleteReview = (id) => api.delete(`/content/reviews/${id}`).then((r) => r.data);

// Registrations
export const createRegistration = (data) => api.post("/registrations", data).then((r) => r.data);
export const listRegistrations = (params) =>
    api.get("/registrations", { params }).then((r) => r.data);
export const updateRegistration = (id, data) =>
    api.put(`/registrations/${id}`, data).then((r) => r.data);
export const deleteRegistration = (id) => api.delete(`/registrations/${id}`).then((r) => r.data);
export const exportRegistrationsCsvUrl = () => `${API}/registrations/export.csv`;

// Auth
export const login = (email, password) =>
    api.post("/auth/login", { email, password }).then((r) => r.data);
export const me = () => api.get("/auth/me").then((r) => r.data);
